export class IconeModuloUtils {
  private static readonly PASTA_POR_ICONE: Record<string, string> = {
    home: 'home',
    chat: 'operacoes',
    edit: 'cadastros',
    settings: 'config',
    monit: 'monitoramento',
    relatorios: 'relatorios',
    disparos: 'disparos'
  };


  public static caminho(iconeModulo: string, sufixo: '' | '-selecionado' | '-roxo'): string {
    const pasta = IconeModuloUtils.PASTA_POR_ICONE[iconeModulo];
    const base = './assets/icones/redesign/modulos-rotinas/';
    return pasta
      ? `${base}${pasta}/${iconeModulo}${sufixo}.svg`
      : `${base}${iconeModulo}${sufixo}.svg`;
  }
}
